import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import QRCode from 'qrcode';
import * as Styled from '../DetailLeftBlock/DetailLeftBlock.styles';
import * as actionsOrder from '../../actions';
import { selectors as selectorsLogin } from '../../../LoginPage/reducer';
import { OrderTableData } from '../../../OrdersPage/types';
import useIsMobile from '../../../../global/hooks/useIsMobile';

const GLOVO_SUPPORT_PHONE = '+77080556008';

interface ContactClientButtonProps {
  data: OrderTableData;
}

const ContactClientButton = ({ data }: ContactClientButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const userData = useSelector(selectorsLogin.userData);

  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [qrSrc, setQrSrc] = useState<string | null>(null);

  const openCall = async () => {
    if (isMobile) {
      window.location.href = `tel:${GLOVO_SUPPORT_PHONE}`;
    } else {
      const dataUrl = await QRCode.toDataURL(`tel:${GLOVO_SUPPORT_PHONE}`, {
        errorCorrectionLevel: 'M',
        margin: 1,
        scale: 8,
      });
      setQrSrc(dataUrl);
      setIsQrModalOpen(true);
    }
  };

  const handleInitCall = async () => {
    const formattedOrder = data.orderNumber.replace(/№/g, '');
    dispatch(
      actionsOrder.initAppCall.request({
        orderCode: formattedOrder,
        pharmacistPhone: userData?.phone,
      })
    );

    await openCall();
  };

  const handleInitSupportCall = async () => {
    const formattedOrder = data.orderNumber.replace(/№/g, '');
    dispatch(
      actionsOrder.initAppCall.request({
        orderCode: formattedOrder,
        pharmacistPhone: userData?.phone,
        service: data.userSource === 'wolt_user' ? 'wolt' : 'glovo',
      })
    );

    await openCall();
  };

  return (
    <>
      <button
        className="contact-client-button"
        type="button"
        onClick={handleInitCall}
      >
        {t('OrdersPage.OrderDetailedModal.CONTACT_CLIENT')}
      </button>

      {data.userSource === 'glovo_user' && (
        <button
          className="contact-client-button"
          type="button"
          onClick={handleInitSupportCall}
        >
          {t('OrdersPage.OrderDetailedModal.CONTACT_SUPPORT_BUTTON')}
        </button>
      )}

      <Modal open={isQrModalOpen} onClose={() => setIsQrModalOpen(false)}>
        <Styled.QrModalContent>
          {qrSrc && <Styled.QrBig alt="QR" src={qrSrc} />}
          <Styled.QrPhoneText>
            {t('OrdersPage.OrderDetailedModal.PHONE_FROM_TO', {
              pharmaciestPhone: `+${userData.phone}`,
              atsPhone: GLOVO_SUPPORT_PHONE,
            })}
          </Styled.QrPhoneText>
        </Styled.QrModalContent>
      </Modal>
    </>
  );
};

export default ContactClientButton;
